import { DocumentOrientation } from "../drawer/types";
import { isADMFormat, isEDDMFormat } from "utils/formats";
import { getEffectiveFormat } from "./formatsStore";

// The orientation a design opens with when nothing is saved yet: mailers are landscape, the rest use the format default.
export const defaultOrientationFor = (formatCode?: string | null): DocumentOrientation => {
  if (!formatCode) return DocumentOrientation.Portrait;
  if (isADMFormat(formatCode) || isEDDMFormat(formatCode)) return DocumentOrientation.Landscape;
  return getEffectiveFormat(formatCode)?.defaultOrientation ?? DocumentOrientation.Portrait;
};
